module.exports = __webpack_public_path__ + "img/ic_linkedin.eec8817d.svg";